import { useEffect, useState } from "react";
import "./App.css";
import Singular from "./components/Singular";
const logo = require("./components/logo.png");
function App() {
  const [data, setData] = useState({});
  useEffect(() => {
    fetch(
      "https://raw.githubusercontent.com/anshinx/react-hasbihall/menu-json/menufs"
    )
      .then((res) => res.json())
      .then((data) => {
        setData(data);
        console.log(data);
      });
  }, []);

  return (
    <div className="App">
      <header className="center">
        <img src={logo} alt="logo" width={"250ram"} />
      </header>
      <div className="row">
        <div className="bg">
          <ul className="list">
            <li>
              <a href="#hots" className="list">
                Sıcak İçecekler
              </a>
            </li>
            <li>
              <a href="#cofee" className="list">
                Kahveler
              </a>
            </li>
            <li>
              <a href="#colds" className="list">
                Soğuk İçecekler
              </a>
            </li>
            <li>
              <a href="#meals" className="list">
                Özel Lezzetler
              </a>
            </li>
            <li>
              <a href="#desserts" className="list">
                Tatlılar
              </a>
            </li>
          </ul>
        </div>
        <div className="card col-md-12 m-1 center" id="hots">
          <h1>Sıcak İçecekler</h1>
        </div>
        {data["hots"] &&
          data["hots"].map((item, index) => {
            return (
              <div className="col-md-4 col-sm-4 col-xs-4 m-1">
                <Singular key={index} data={item} />
              </div>
            );
          })}
        <div className="card col-md-12 m-1 center" id="cofee">
          <h1>Kahveler</h1>
        </div>
        {data["cofee"] &&
          data["cofee"].map((item, index) => {
            return (
              <div className="col-md-4 col-sm-4 col-xs-4 m-1">
                <Singular key={index} data={item} />
              </div>
            );
          })}
        <div className="card col-md-12 m-1 center" id="colds">
          <h1>Soğuk İçecekler</h1>
        </div>
        {data["cold"] &&
          data["cold"].map((item, index) => {
            return (
              <div className="col-md-4 col-sm-4 col-xs-4 m-1">
                <Singular key={index} data={item} />
              </div>
            );
          })}

        <div className="card col-md-12 m-1 center" id="meals">
          <h1>Özel Lezzetler</h1>
        </div>
        {data["meals"] &&
          data["meals"].map((item, index) => {
            return (
              <div className="col-md-4 col-sm-4 col-xs-4 m-1">
                <Singular key={index} data={item} />
              </div>
            );
          })}
        <div className="card col-md-12 m-1 center" id="desserts">
          <h1>Tatlılar</h1>
        </div>
        {data["desserts"] &&
          data["desserts"].map((item, index) => {
            return (
              <div className="col-md-4 col-sm-4 col-xs-4 m-1">
                <Singular key={index} data={item} />
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default App;
